import type { ContestProductGroupKey, ProductGroupConfig } from '../../types';

export const productGroupsConfig: Record<ContestProductGroupKey, ProductGroupConfig> = {
    'logo-design': {
        name: 'logo-design-contest',
        designInspirationCategoryKey: 'logo-design',
        relatedProductsNames: [
            'bronze-logo-brand-identity-pack-contest',
            'bronze-logo-brand-guide-contest',
            'bronze-logo-social-media-pack-contest',
        ],
    },
    'brand-identity-pack': {
        name: 'logo-brand-identity-pack-contest',
        designInspirationCategoryKey: 'brand-identity-pack',
        relatedProductsNames: [
            'bronze-logo-brand-guide-contest',
            'bronze-logo-business-card-contest',
            'bronze-logo-contest',
        ],
    },
    'logo-brand-guide': {
        name: 'logo-brand-guide-contest',
        designInspirationCategoryKey: 'logo-brand-guide',
        relatedProductsNames: [
            'bronze-logo-brand-identity-pack-contest',
            'bronze-logo-social-media-pack-contest',
            'bronze-logo-contest',
        ],
    },
    'logo-business-card-design': {
        name: 'logo-business-card-design-contest',
        designInspirationCategoryKey: 'logo-business-card-design',
        relatedProductsNames: [
            'bronze-logo-brand-identity-pack-contest',
            'bronze-logo-brand-guide-contest',
            'bronze-logo-contest',
        ],
    },
    'social-media-pack': {
        name: 'logo-social-media-pack-contest',
        designInspirationCategoryKey: 'social-media-pack',
        relatedProductsNames: [
            'bronze-logo-brand-identity-pack-contest',
            'bronze-logo-brand-guide-contest',
            'bronze-logo-contest',
        ],
    },
    'brand-starter-pack': {
        name: 'brand-starter-pack-contest',
        designInspirationCategoryKey: 'brand-identity-pack',
        relatedProductsNames: [
            'bronze-brand-launch-pack-contest',
            'bronze-logo-contest',
            'bronze-logo-social-media-pack-contest',
        ],
    },
    'brand-launch-pack': {
        name: 'brand-launch-pack-contest',
        designInspirationCategoryKey: 'brand-identity-pack',
        relatedProductsNames: [
            'bronze-logo-brand-guide-contest',
            'bronze-logo-social-media-pack-contest',
            'bronze-logo-contest',
        ],
    },
};
